export default __webpack_public_path__ + "static/media/Resume.d44ff1d4.pdf";